import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-[calc(100%-72px)] max-h-[[calc(100%-72px)]] overflow-auto" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SideTab',
  props: {
    rolesSelected: {
        type: Boolean,
        default: false,
    },
    interventionTypesSelected: {
        type: Boolean,
        default: false,
    },
    primaryDiagnosisSelected: {
        type: Boolean,
        default: false,
    },
    formOptionsSelected: {
        type: Boolean,
        default: false,
    },
    departmentSelected: {
        type: Boolean,
        default: false,
    },
    telecpuLocationsSelected: {
        type: Boolean,
        default: false,
    },
    dataDictionarySelected: {
        type: Boolean,
        default: false,
    },
    notificationsSelected: {
        type: Boolean,
        default: false,
    },
    regionSelected: {
        type: Boolean,
        default: false,
    },
    provinceSelected: {
        type: Boolean,
        default: false,
    },
    citySelected: {
        type: Boolean,
        default: false,
    },
    barangaySelected: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "/settings/roles/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.rolesSelected ? 'bg-primary-200' : ''])
    }, " Roles ", 2),
    _createElementVNode("a", {
      href: "/settings/intervention-types/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.interventionTypesSelected ? 'bg-primary-200' : ''])
    }, " Intervention Types ", 2),
    _createElementVNode("a", {
      href: "/settings/primary-diagnosis/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.primaryDiagnosisSelected ? 'bg-primary-200' : ''])
    }, " Primary Diagnosis ", 2),
    _createElementVNode("a", {
      href: "/settings/form-options/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.formOptionsSelected ? 'bg-primary-200' : ''])
    }, " Form Options ", 2),
    _createElementVNode("a", {
      href: "/settings/department/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.departmentSelected ? 'bg-primary-200' : ''])
    }, " Department ", 2),
    _createElementVNode("a", {
      href: "/settings/telecpu-locations/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.telecpuLocationsSelected ? 'bg-primary-200' : ''])
    }, " TeleCPU Locations ", 2),
    _createElementVNode("a", {
      href: "/settings/data-dictionary/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.dataDictionarySelected ? 'bg-primary-200' : ''])
    }, " Data Dictionary ", 2),
    _createElementVNode("a", {
      href: "/settings/regions/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.regionSelected ? 'bg-primary-200' : ''])
    }, " Regions ", 2),
    _createElementVNode("a", {
      href: "/settings/provinces/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.provinceSelected ? 'bg-primary-200' : ''])
    }, " Province ", 2),
    _createElementVNode("a", {
      href: "/settings/city/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.citySelected ? 'bg-primary-200' : ''])
    }, " City ", 2),
    _createElementVNode("a", {
      href: "/settings/barangay/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.barangaySelected ? 'bg-primary-200' : ''])
    }, " Barangay ", 2),
    _createElementVNode("a", {
      href: "/settings/manifest/index",
      class: _normalizeClass(["block p-6 text-sm font-semibold border-b border-gray-200", __props.notificationsSelected ? 'bg-primary-200' : ''])
    }, " Data Manifest ", 2)
  ]))
}
}

})